import { storyblokEditable } from "gatsby-source-storyblok"

import PlansBanner from "../../../V2/Banners/PlansBanner"

import { storyblokLinkToYocoLink } from "@utils/storyblok"
import React from "react"

const StoryblokPlansBanner = ({
  blok,
}: Storyblok.BlokProps<Storyblok.PlansBanner>) => {
  return (
    <PlansBanner
      superscript={blok.superscript}
      superscriptHighlightedWord={blok.superscriptHighlightedWord}
      superscriptHighlightColor={blok.superscriptHighlightColor}
      title={blok.title}
      description={blok.description}
      infoCards={blok.infoCards?.map((card) => ({
        iconUrl: card.icon.filename,
        iconAlt: card.icon.alt ?? "",
        title: card.title,
        description: card.description,
        backgroundColor: card.backgroundColor,
      }))}
      worksWith={blok.worksWith?.map((item) => ({
        text: item.text,
        iconUrl: item.icon.filename,
        iconAlt: item.icon.alt ?? "",
        link: storyblokLinkToYocoLink(item.link),
      }))}
      plan={
        blok.plan
          ? {
              title: blok.plan.content.title,
              subtitle: blok.plan.content.subtitle,
              monthlyCost: blok.plan.content.monthlyCost,
              priceSubscript: blok.plan.content.priceSubscript,
            }
          : undefined
      }
      priceSubscript={blok.priceSubscript}
      priceSubscriptHighlight={blok.priceSubscriptHighlight}
      priceSubscriptHighlightColor={blok.priceSubscriptHighlightColor}
      backgroundColor={blok.backgroundColor}
      secondaryBackgroundColor={blok.secondaryBackgroundColor}
      sectionColor={blok.sectionColor}
      primaryCtaText={blok.primaryCtaText}
      primaryCtaLink={storyblokLinkToYocoLink(blok.primaryCtaLink) ?? ""}
      secondaryCtaText={blok.secondaryCtaText}
      secondaryCtaLink={storyblokLinkToYocoLink(blok.secondaryCtaLink)}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryblokPlansBanner
